import { render, staticRenderFns } from "./swingLayout.vue?vue&type=template&id=0847c4f3&scoped=true&"
import script from "./swingLayout.vue?vue&type=script&lang=js&"
export * from "./swingLayout.vue?vue&type=script&lang=js&"
import style0 from "./swingLayout.vue?vue&type=style&index=0&id=0847c4f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847c4f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0847c4f3')) {
      api.createRecord('0847c4f3', component.options)
    } else {
      api.reload('0847c4f3', component.options)
    }
    module.hot.accept("./swingLayout.vue?vue&type=template&id=0847c4f3&scoped=true&", function () {
      api.rerender('0847c4f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/swingLayout.vue"
export default component.exports